import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25RouterLinkDirective } from "../../s25-nav-bar/s25.router.link.directive";
import { S25States } from "../../../services/state/state.map";

@TypeManagerDecorator("s25-ng-se-layout-org-link-cell")
@Component({
    selector: "s25-ng-se-layout-org-link-cell",
    standalone: true,
    imports: [S25RouterLinkDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <a
            class="connect25-detail-link"
            s25-ng-router-link
            [stateName]="seOrganizationDetailsStateName"
            [stateParams]="organizationDetailLinkParams()"
            [attr.aria-label]="'View ' + itemName() + ' organization details'"
        >
            {{ itemName() }}
        </a>
    `,
    styles: `
        .connect25-detail-link {
            font-weight: 500;
            color: var(--color--link-text, #0c447c);
            text-decoration: none;
        }
        .connect25-detail-link:hover {
            text-decoration: underline;
        }
    `,
})
export class SeLayoutOrgLinkCellComponent {
    readonly itemId = input.required<number>();
    readonly itemName = input.required<string>();

    readonly seOrganizationDetailsStateName = S25States.names.seOrganizationDetails;
    readonly organizationDetailLinkParams = computed(
        (): S25States.ParamsForName<"seOrganizationDetails"> => ({ itemId: this.itemId() }),
    );
}
